import "./Spinner.scss";

export interface SpinnerProps {
  className?: string;
  size?: string;
  width?: string;
  backColor?: string;
  frontColor?: string;
}

const Spinner = (props: SpinnerProps) => (
  <div className="Spinner" aria-busy="true" aria-live="polite">
    <div
      className="sp"
      style={{
        width: props.size || "32px",
        height: props.size || "32px",
        borderWidth: props.width || "4px",
        borderLeftColor: props.backColor || "var(--blue15)",
        borderRightColor: props.backColor || "var(--blue15)",
        borderBottomColor: props.backColor || "var(--blue15)",
        borderTopColor: props.frontColor || "var(--blue)",
      }}
    />
  </div>
);

export default Spinner;
